var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon, _rect, _polygon2, _polygon3, _polygon4, _polyline, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path18, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#186eb4;}.cls-2{fill:#e48f25;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#faef6f;}.cls-5{fill:#8ec6ea;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:#1197d3;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:#95cd9d;}.cls-10{fill:#67bc6c;}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:#ec463f;}.cls-13{fill:#761116;}.cls-14{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.54,
    y1: 27.51,
    x2: 87.54,
    y2: 47.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fce200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 56.51,
    y1: 29.61,
    x2: 76.02,
    y2: 45.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1b89c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00649b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 45.27,
    y1: 30.16,
    x2: 45.27,
    y2: 47.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#279e49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#078753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 19.98,
    y1: 28.45,
    x2: 22.98,
    y2: 46.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d52231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b72235"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.94,83V59.87h9.4c4.7,0,7.33,3.2,7.33,7s-2.67,7-7.33,7h-6.49V83Zm13.71-16.19A4.33,4.33,0,0,0,166,62.44h-6.14v8.82H166A4.32,4.32,0,0,0,170.65,66.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.31,83V81.13a7.3,7.3,0,0,1-5.61,2.33c-2.84,0-5.9-1.91-5.9-5.56s3-5.52,5.9-5.52a7.2,7.2,0,0,1,5.61,2.25v-3c0-2.22-1.82-3.51-4.28-3.51a6.66,6.66,0,0,0-5.19,2.33l-1.23-1.81a8.92,8.92,0,0,1,6.77-2.77c3.61,0,6.56,1.59,6.56,5.66V83Zm0-3.54V76.3a5.77,5.77,0,0,0-4.63-2c-2.49,0-4.21,1.53-4.21,3.65s1.72,3.68,4.21,3.68A5.68,5.68,0,0,0,187.31,79.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.23,83V66.26h2.63v2.68a7.31,7.31,0,0,1,5.65-3.06v2.67a10.2,10.2,0,0,0-1-.06,6.22,6.22,0,0,0-4.63,2.67V83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.33,79.53v-11h-2.81V66.26h2.81V61.68H210v4.58h3.43v2.29H210V79c0,1.25.56,2.15,1.68,2.15a2.52,2.52,0,0,0,1.79-.73l.77,2a4.27,4.27,0,0,1-3.12,1.08C208.59,83.46,207.33,82,207.33,79.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.58,83v-11c0-3-1.54-3.89-3.82-3.89a6.58,6.58,0,0,0-5,2.61V83h-2.64V66.26h2.64v2.43a8.31,8.31,0,0,1,6.06-2.84c3.51,0,5.37,1.77,5.37,5.41V83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.49,74.63c0-4.86,3.51-8.78,8.35-8.78,5.12,0,8.14,4,8.14,9v.66H238.3a5.91,5.91,0,0,0,6.06,5.8,7.42,7.42,0,0,0,5.27-2.15l1.26,1.7a9.39,9.39,0,0,1-6.74,2.61C239.1,83.46,235.49,79.88,235.49,74.63ZM243.8,68a5.61,5.61,0,0,0-5.54,5.56h11.12A5.45,5.45,0,0,0,243.8,68Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.22,83V66.26h2.63v2.68a7.29,7.29,0,0,1,5.64-3.06v2.67a10,10,0,0,0-1-.06,6.22,6.22,0,0,0-4.63,2.67V83Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.84,51l-2.11-5.67H164.38L162.27,51H154.2l12.89-33.47H176L188.92,51Zm-9.28-26.34L166.34,39h10.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.33,51V47.9a11.52,11.52,0,0,1-8.53,3.66c-5.32,0-7.83-2.91-7.83-7.62V26.73h6.37v14.7c0,3.36,1.76,4.46,4.47,4.46a7.13,7.13,0,0,0,5.52-2.76V26.73h6.37V51Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.07,44.89V32.3h-4V26.73h4V20.1h6.37v6.63h4.92V32.3h-4.92V43.18c0,1.56.81,2.71,2.21,2.71a3.2,3.2,0,0,0,2.21-.75L231.21,50c-1,.85-2.65,1.55-5.31,1.55C221.43,51.56,219.07,49.25,219.07,44.89Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.88,51V36.21c0-3.36-1.76-4.41-4.47-4.41a7,7,0,0,0-5.51,2.8V51h-6.43V17.49h6.43V29.84a11.22,11.22,0,0,1,8.48-3.72c5.31,0,7.87,2.91,7.87,7.63V51Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.76,38.82c0-6.87,4.82-12.7,12.8-12.7S285.4,32,285.4,38.82s-4.81,12.74-12.84,12.74S259.76,45.69,259.76,38.82Zm19,0c0-3.76-2.21-7-6.22-7s-6.17,3.26-6.17,7,2.21,7.07,6.17,7.07S278.78,42.63,278.78,38.82Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.92,51V26.73h6.37V30A10.6,10.6,0,0,1,303,26.12v6.23a8.11,8.11,0,0,0-1.75-.15c-2.11,0-4.92,1.2-6,2.76V51Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.12,20.3a3.79,3.79,0,0,1,7.58,0,3.79,3.79,0,1,1-7.58,0ZM305.73,51V26.73h6.37V51Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.11,51V46.19L327.05,32.3H316.11V26.73h19.62v4.56l-11.14,14.1h11.34V51Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.39,38.82a12.37,12.37,0,0,1,12.54-12.7c7.28,0,12.14,5.42,12.14,13.3v1.51h-18c.45,3,2.86,5.41,7,5.41A10.17,10.17,0,0,0,358.46,44l2.86,4.21c-2.41,2.21-6.22,3.36-10,3.36C344,51.56,338.39,46.59,338.39,38.82Zm12.54-7.48A5.59,5.59,0,0,0,345,36.51H357C356.75,34.2,355.15,31.34,350.93,31.34Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.09,51V47.85a9.31,9.31,0,0,1-7.47,3.71c-6.07,0-10.74-4.61-10.74-12.74,0-7.88,4.57-12.7,10.74-12.7a9.18,9.18,0,0,1,7.47,3.72V17.49h6.42V51Zm0-7.83V34.55a6.91,6.91,0,0,0-5.47-2.75c-3.66,0-6.17,2.85-6.17,7s2.51,7.07,6.17,7.07A6.89,6.89,0,0,0,383.09,43.13Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.15 23.88 100.15 45.15 97.26 48.04 97.21 27.22 100.15 23.88"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 77.81,
    y: 27.22,
    width: 19.45,
    height: 20.82
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "80.86 23.9 77.81 27.22 97.26 27.22 100.15 23.88 80.86 23.9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "56.78 24.81 75.9 22.15 74.3 26.74 56.18 29.61 56.26 26.33 56.78 24.81"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "74.3 26.74 76.95 45.39 58.09 48.04 55.55 30.01 56.65 29.15 74.3 26.74"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "75.9 22.15 75.92 22.26 78.4 41.37 76.95 45.39 74.3 26.74"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "40.62 23.22 57.55 30.86 49.91 48.21 32.98 40.57 40.62 23.22"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "38.86 17.28 40.62 23.22 57.55 30.86 56.13 25.19 38.86 17.28"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "38.86 17.28 32.05 33.46 32.98 40.57 40.62 23.22 38.86 17.28"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "29.41 26.71 32.21 45.07 13.49 48 10.48 29.61 29.41 26.71"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "10.48 29.61 11.8 23.05 30.7 20.03 29.41 26.71 10.48 29.61"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "30.7 20.03 33.47 38.56 32.21 45.07 29.41 26.71 30.7 20.03"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M94.29,34.71a7.75,7.75,0,0,0-1.7-2.6,7.27,7.27,0,0,0-5.34-2.22,7.63,7.63,0,0,0-2.92.56,7.12,7.12,0,0,0-2.43,1.66,7.62,7.62,0,0,0-1.7,2.59,8.78,8.78,0,0,0-.56,3.16A8.65,8.65,0,0,0,80.21,41a7.81,7.81,0,0,0,1.69,2.62,7.06,7.06,0,0,0,2.4,1.63,7.67,7.67,0,0,0,3,.56,7.53,7.53,0,0,0,2.9-.56,7.37,7.37,0,0,0,2.43-1.63A7.71,7.71,0,0,0,94.29,41a8.87,8.87,0,0,0,0-6.31Zm-4,6.86a4.14,4.14,0,0,1-6.11,0,5.66,5.66,0,0,1-1.12-3.71,5.73,5.73,0,0,1,1.12-3.77,4.13,4.13,0,0,1,6.11,0,5.78,5.78,0,0,1,1.12,3.77A5.65,5.65,0,0,1,90.3,41.57ZM23,37.35Zm4.39,4.8a1.29,1.29,0,0,0-.58-.4,3,3,0,0,0-.91-.12,6.23,6.23,0,0,0-1.14.11l-4.94.84a4.66,4.66,0,0,1,.57-1.49,20.23,20.23,0,0,1,1.65-2.46h0l.57-.76.39-.52a12.14,12.14,0,0,0,2.1-3.63,7.62,7.62,0,0,0,.28-1.63c0-.15,0-.29,0-.44a7.46,7.46,0,0,0-.1-1.16,3,3,0,0,0-.26-.86,1.17,1.17,0,0,0-.44-.51,1.65,1.65,0,0,0-.85-.18,7,7,0,0,0-1.1.11L17,30a2.94,2.94,0,0,0-1.53.63,1.22,1.22,0,0,0-.39.92,1.5,1.5,0,0,0,0,.29,1.28,1.28,0,0,0,.74,1,2.08,2.08,0,0,0,.87.16,4.29,4.29,0,0,0,.76-.07l4.78-.81a2.26,2.26,0,0,1,0,.26,2.57,2.57,0,0,1-.15.87A6.92,6.92,0,0,1,21,35l-.74.92a22.67,22.67,0,0,0-2.77,4h0a8.42,8.42,0,0,0-.82,2.25,6.08,6.08,0,0,0-.13,1.24,5.59,5.59,0,0,0,.06.83,3.37,3.37,0,0,0,.29.94,1.27,1.27,0,0,0,.49.55,1.84,1.84,0,0,0,.84.14,12,12,0,0,0,1.93-.21l5.18-.88a4.36,4.36,0,0,0,1.93-.68,1.21,1.21,0,0,0,.45-1,1.63,1.63,0,0,0,0-.31A1.26,1.26,0,0,0,27.4,42.15ZM50.9,29.74a7.52,7.52,0,0,0-5.28-2.26h0a7.22,7.22,0,0,0-2.88.65h0a7.9,7.9,0,0,0-2.6,1.81,9.4,9.4,0,0,0-1.79,2.8A9.25,9.25,0,0,0,37.56,36c0,.12,0,.24,0,.36A8.12,8.12,0,0,0,38,39.12a6.88,6.88,0,0,0,1.52,2.49A7.31,7.31,0,0,0,42,43.27h0a7.14,7.14,0,0,0,2.84.6h0a7.34,7.34,0,0,0,2.87-.62h0a8.29,8.29,0,0,0,2.61-1.84,9.61,9.61,0,0,0,2.55-6v-.31a8.13,8.13,0,0,0-.51-2.83A7.28,7.28,0,0,0,50.9,29.74ZM49,37.3a6.06,6.06,0,0,1-2.52,3.1,3.5,3.5,0,0,1-1.73.46,4.12,4.12,0,0,1-1.59-.35A3.66,3.66,0,0,1,41,38.05a4.42,4.42,0,0,1-.16-1.21,7.08,7.08,0,0,1,.64-2.77A6.13,6.13,0,0,1,44,30.91a3.5,3.5,0,0,1,1.73-.46,4,4,0,0,1,1.61.35,3.59,3.59,0,0,1,2.22,2.46,4.68,4.68,0,0,1,.16,1.19A7.39,7.39,0,0,1,49,37.3Zm22.06-7A2.15,2.15,0,0,0,70.49,29a1.35,1.35,0,0,0-.94-.35l-.29,0a1.44,1.44,0,0,0-1.09.67,1.77,1.77,0,0,0-.25,1,3.64,3.64,0,0,0,0,.45l.69,4.86-5.42.8-.69-4.86a2.19,2.19,0,0,0-.59-1.3,1.35,1.35,0,0,0-.94-.36,1.18,1.18,0,0,0-.26,0,1.5,1.5,0,0,0-1.13.66,1.81,1.81,0,0,0-.26,1,3.91,3.91,0,0,0,0,.46l1.86,12.63a2,2,0,0,0,.62,1.3,1.39,1.39,0,0,0,1,.34l.32,0a1.37,1.37,0,0,0,1-.66,1.85,1.85,0,0,0,.23-1,3.93,3.93,0,0,0,0-.46l-.76-5,5.42-.8.76,5a2,2,0,0,0,.61,1.3,1.6,1.6,0,0,0,1.24.32,1.42,1.42,0,0,0,1.09-.67,1.79,1.79,0,0,0,.24-1,2.45,2.45,0,0,0,0-.46Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.81,
    y: 17.28,
    width: 1.18,
    height: 34.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoho);
export default __webpack_public_path__ + "static/media/zoho.1c9f8487fb54fc65f81f6845a5e9995f.svg";
export { ForwardRef as ReactComponent };